import { render, staticRenderFns } from "./ADDubEditorModal.vue?vue&type=template&id=79fd8fde&scoped=true&"
import script from "./ADDubEditorModal.vue?vue&type=script&lang=js&"
export * from "./ADDubEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./ADDubEditorModal.vue?vue&type=style&index=0&id=79fd8fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd8fde",
  null
  
)

export default component.exports